import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/icon-github.svg'
import _imports_2 from '@/assets/images/logo-brasil-io.svg'
import _imports_3 from '@/assets/images/logo-open-knowledge.svg'


const _hoisted_1 = { class: "c-footer bg-primary-base p-10 bottom-0 static" }
const _hoisted_2 = { class: "c-footer__content container bg-background-purpleLight flex flex-col xl:flex-row justify-center items-center p-8 text-white rounded-lg" }
const _hoisted_3 = { class: "c-footer__content-logo xl:w-1/5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Perfil Político",
  class: "w-full"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "c-footer__content-description mx-14 my-5 xl:my-0 text-left text-base font-regular" }, [
  /*#__PURE__*/_createElementVNode("p", null, " O Perfil Político é um projeto que permite ao eleitorado comparar os perfis das candidaturas às eleições gerais do Brasil, para saber quem realmente o representa. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "c-footer__content-link-project flex w-full xl:w-1/6 items-center justify-center bg-opacity-10 bg-white p-3 rounded-lg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Github"
  }),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://github.com/okfn-brasil/perfil-politico-frontend",
      target: "_blank",
      rel: "noopener noreferrer",
      class: "ml-2 hover:underline"
    }, "Ver Github")
  ])
], -1)
const _hoisted_7 = { class: "c-footer__content-actions container flex flex-col lg:flex-row lg:justify-between lg:items-center items-start text-white mt-10" }
const _hoisted_8 = { class: "flex flex-col mb-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-xl mr-3 lg:mb-0 mb-4" }, "Link Úteis:")
], -1)
const _hoisted_10 = { class: "flex flex-row flex-wrap items-center font-light text-base" }
const _hoisted_11 = { class: "lg:mr-5 mr-5 lg:mb-0 mb-5 hover:underline" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Sobre o projeto")
const _hoisted_13 = { class: "lg:mr-5 lg:mb-0 mb-5 hover:underline" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Perguntas frequentes")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", { class: "lg:mr-5 lg:mb-0 mb-5 hover:underline" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://apoia.se/serenata",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "ml-2 text-white hover:underline"
  }, "Apoie o projeto")
], -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col mb-5\"><div class=\"mb-5\"><h3 class=\"font-bold text-xl mr-3 sm:mb-0 mb-4\">Parceiros:</h3></div><div class=\"flex flex-row flex-wrap items-center\"><a href=\"https://brasil.io/home/\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"" + _imports_2 + "\" alt=\"Brasil.io\"></a></div></div><div class=\"flex flex-col items-start\"><div class=\"mb-5\"><h3 class=\"font-bold text-xl mr-3 sm:mb-0 mb-4\">Realização:</h3></div><div class=\"flex flex-row flex-wrap items-center font-regular text-xs\"><a href=\"https://ok.org.br/\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"" + _imports_3 + "\" alt=\"Open Knowledge\"></a></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: { name: 'Home' } }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, { to: { name: 'About' } }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_router_link, { to: '/#perguntas-frequentes' }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _hoisted_15
        ])
      ]),
      _hoisted_16
    ])
  ]))
}